import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { OktaAuthEventListener } from '../auto-listener/okta-auth-event-listener.service';

declare global {
    interface Window {
        oktaTest?: {
            renewNow: () => Promise<void>;
            renewByExpiry: () => Promise<void>;
            renewWithInvalidRefresh: () => Promise<void>;
        };
    }
}

@Injectable({
    providedIn: 'root',
})
export class OktaTestCommandsService {
    constructor(private readonly oktaAuthEventService: OktaAuthEventListener) {}

    register(): void {
        console.log('environment.production', environment.production)
        if (environment.production) {
            this.oktaAuthEventService.ensureDevModeForTest();
        }

        window.oktaTest = {
            renewNow: () => this.oktaAuthEventService.forceRenewForTest(),
            renewByExpiry: () => this.oktaAuthEventService.forceRenewViaExpirationForTest(),
            renewWithInvalidRefresh: () => this.oktaAuthEventService.forceRenewErrorForTest(),
        };
    }

    unregister(): void {
        if (window.oktaTest) {
            delete window.oktaTest;
        }
    }
}